export const SET_SORT_OPTION = 'SET_SORT_OPTION';

export const setSortOption = (option) => ({
    type: SET_SORT_OPTION,
    payload: option,
});